const Mock = require("mockjs");

const data = Mock.mock({
  "items|30": [
    {
      id: "@id",
      title: 'mq-@string("lower",  7, 10 )',
      "status|1": ["正常", "未知", "故障"],
      author: "@last",
      display_time: "@datetime",
      pageviews: "@integer(300, 5000)",
      ip_address: "@ip",
    },
  ],
  "status|20": [
    {
      id: "@id",
      ip_address: "@ip",
      "status|1": ["在线", "未知", "离线"],
      timer: "@time",
      delay: "@natural(1, 1000)",
      last_time: '@datetime("yyyy-MM-dd HH:mm")',
    },
  ],
});

module.exports = [
  {
    url: "/xiongsu/table/list",
    type: "get",
        response: () => {
            // config
            const items = data.items;
            return {
                code: 20000,
                data: {
                    total: items.length,
                    items: items,
                },
            };
        },
  },
  {
    url: "/xiongsu/table/status",
    type: "get",
      response: () => {
          // config
          const items = data.status;
          return {
              code: 20000,
              data: {
                  total: items.length,
                  items: items,
              },
          };
      },
  },
];
